import * as positionService from "./position.service";

const INITIAL_STATE = {
  // 岗位
  position: {},
  // 岗位列表
  positionList: [],
};

const position = {
  state: {
    ...INITIAL_STATE,
  },
  actions: {
    getPositionList({ dispatch }, param) {
      return positionService.getPositionList(param).then(res => {
        dispatch({ type: "position/getPositionList", payload: res.data });
        return res;
      });
    },
    switchPosition({ dispatch }, param) {
      return positionService.switchPosition(param).then(res => {
        dispatch({ type: "position/switchPosition", payload: res.data });
        dispatch({ type: "organization/switchOrganization", payload: res.data });
        return res;
      });
    },
  },
  reducers: {
    getPositionList(prevState, payload) {
      return {
        ...prevState,
        positionList: [...payload],
      };
    },
    switchPosition(prevState, payload) {
      const { position, } = payload;
      return {
        ...prevState,
        position: { ...position },
      };
    },
  }
}

export default position;
